import { render, staticRenderFns } from "./IssuesOfSimulationPage.vue?vue&type=template&id=9836b468"
import script from "./IssuesOfSimulationPage.vue?vue&type=script&lang=js"
export * from "./IssuesOfSimulationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports